@if (isLoading) {
	<div class="loading-overlay">
		<img class="spinner" src="./assets/spinner2.gif" />
	</div>
}

@if (loadingSubject | async) {
	<div class="overlay" style="z-index: 999999999; background-color: rgba(255, 255, 255, 0.8); position: absolute; top: 0; left: 0; right: 0; bottom: 0; display: flex; flex-direction: row; justify-content: center; align-items: center">
		<img src="./assets/spinner2.gif" />
	</div>
}

<div class="service-header-wrapper">
	<h2 class="mat-heading" style="flex: 2">{{ 'calculations.sidebar.matrices' | translate }}</h2>
	<div class="service-header-buttons">
		<div class="acies-density-high acies-list-search-field">
			<mat-form-field>
				<input matInput [placeholder]="'insights.administration.users.search' | translate" [(ngModel)]="matricesFilter" />
				<button mat-icon-button matPrefix>
					<mat-icon svgIcon="acies_search"></mat-icon>
				</button>
			</mat-form-field>
		</div>
		<header-sub-menu [favoriteItems]="favoriteItems"></header-sub-menu>
	</div>
</div>

<app-generictable
	[hidden]="(count$ | async) <= 0"
	[tableData]="matricesData | async"
	[tableColumns]="registerTableColumns"
	[pageSizes]="pageSizes"
	[initialPageSize]="initialPageSize"
	[showFirstLastButtons]="false"
	[filterWord]="matricesFilter"
	[rowActions]="regRowActions"
	(menuEmitter)="handleRowMenuAction($event)"
	(paginatorEmitter)="handleReloadData($event)"
	[totalRowCount]="count$ | async"></app-generictable>
